export class Product {
    public id: string;
    public name: string;
    public loanProgramId: string;
    public productSkillsetId: string;
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/loanprograms/Product.model.ts